import { useQuery, queryOptions } from '@tanstack/react-query';

import httpService from '../../../lib/http.service';
import { QueryConfig } from '../../../lib/react-query';

export const getInvoiceDetailsPdf = ({ invoiceNo }: { invoiceNo: string }): Promise<{ data: Blob }> => {
  return httpService.get(`/invoices/${invoiceNo}/pdf`, {
    responseType: 'blob',
  });
};

export const getInvoiceDetailsPdfQueryOptions = (invoiceNo: string) => {
  return queryOptions({
    queryKey: ['invoice-details-pdf', invoiceNo],
    queryFn: () => getInvoiceDetailsPdf({ invoiceNo }),
  });
};

type UseInvoiceDetailsPdfOptions = {
  invoiceNo: string;
  queryConfig?: QueryConfig<typeof getInvoiceDetailsPdfQueryOptions>;
};

export const useInvoiceDetailsPdf = ({ invoiceNo, queryConfig }: UseInvoiceDetailsPdfOptions) => {
  return useQuery({
    ...getInvoiceDetailsPdfQueryOptions(invoiceNo),
    ...queryConfig,
  });
};
